import { useTranslation } from 'react-i18next';

export default function Hero() {
  const { t } = useTranslation();

  return (
    <section className="relative w-full min-h-[600px] md:min-h-[700px] flex flex-col items-center justify-center bg-background-50 overflow-hidden pt-20">
      <div className="absolute top-0 left-0 w-full h-full">
        <img
          src="https://readdy.ai/api/search-image?query=Soft%20warm%20minimalist%20product%20flat%20lay%20with%20clothing%20accessories%20shoes%20and%20bags%20neatly%20arranged%20on%20light%20cream%20surface%2C%20gentle%20natural%20light%20from%20left%2C%20soft%20beige%20and%20cream%20palette%2C%20dreamy%20atmospheric%20product%20photography%20with%20shallow%20depth%20of%20field%2C%20editorial%20lifestyle%20aesthetic%2C%20clean%20and%20airy%20composition%20with%20plenty%20of%20negative%20space&width=1600&height=900&seq=hero-bg-yoybuy&orientation=landscape"
          alt="YOYBUY Sheet - продуктовая композиция"
          title="YOYBUY Sheet продуктовая композиция"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/30 via-black/15 to-black/40"></div>
      </div>

      <div className="relative z-10 w-full max-w-4xl mx-auto px-4 md:px-6 text-center">
        <div className="inline-flex items-center gap-2 px-4 py-1.5 border border-background-50/30 rounded-full mb-8">
          <span className="w-2 h-2 rounded-full bg-accent-400"></span>
          <span className="text-sm text-background-50/90 font-label tracking-wide">
            YOYBUY Sheet — Умная система заказов из Китая
          </span>
          <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="w-6 h-6 flex items-center justify-center rounded-full bg-background-50/20 hover:bg-background-50/30 transition-colors duration-200 cursor-pointer">
            <i className="ri-information-line text-background-50 text-xs"></i>
          </a>
        </div>

        <h1 className="font-heading text-4xl md:text-6xl lg:text-7xl text-background-50 font-light leading-tight mb-6">
          YOYBUY Sheet
          <br />
          <span className="text-3xl md:text-4xl lg:text-5xl font-normal italic opacity-90">
            Ваш проводник в мире покупок из Китая
          </span>
        </h1>

        <p className="text-background-50/80 text-sm md:text-base max-w-2xl mx-auto mb-10 font-body leading-relaxed">
          {t('heroDescription')}
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="px-8 py-3.5 bg-background-50 text-foreground-900 rounded-full text-sm font-label font-semibold hover:bg-background-100 transition-all duration-200 whitespace-nowrap cursor-pointer"
          >
            {t('goToShop')}
          </a>
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="px-8 py-3.5 border-2 border-background-50/80 text-background-50 rounded-full text-sm font-label font-semibold hover:bg-background-50/10 transition-all duration-200 whitespace-nowrap cursor-pointer"
          >
            {t('buyNow')}
          </a>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 z-10">
        <span className="w-8 h-8 flex items-center justify-center animate-bounce">
          <i className="ri-arrow-down-s-line text-background-50/60 text-2xl"></i>
        </span>
      </div>
    </section>
  );
}